import { useEffect, useState } from "react";
import { findoutLastMonth } from "../utils/findoutLastMonth";
import { actionToBringInLastMonthsSales } from "../components/LastMonthTotalSales/actionToBringInLastMonthsSales";
import { useDispatch, useSelector } from "react-redux";

export function useCalculateLastMonthsSales(product) {
  const dispatch = useDispatch();

  const lastMonth = findoutLastMonth();
  const productLastMonth = product?.lastMonthTotalSales?.calculatedMonth;
  const [salesLastMonth, setSalesLastMonth] = useState(null);

  useEffect(() => {
    if (
      product &&
      product.name &&
      productLastMonth &&
      lastMonth === productLastMonth
    ) {
      setSalesLastMonth(product.lastMonthTotalSales.calculatedTotal);
    } else if (product && product.name) {
      dispatch(
        actionToBringInLastMonthsSales({
          productId: product._id,
          lastMonth,
        })
      );
    }
  }, [product, lastMonth, productLastMonth, dispatch]);

  const bringInLastMonthsSales = useSelector(
    (state) => state.bringInLastMonthsSales
  );
  const { loading, error, lastMonthsTotalSale } = bringInLastMonthsSales;

  // ROUND UP THE NUMBER
  const roundedNum =
    lastMonthsTotalSale > 0
      ? 100 + Math.round((lastMonthsTotalSale - 100) / 50) * 50
      : 100 + Math.round((salesLastMonth - 100) / 50) * 50;

  return {
    loading,
    error,
    lastMonthsTotalSale: roundedNum,
  };
}
